import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// import API from './api';
const isProd = process.env.NODE_ENV === 'production';
import SANITY from './sanityapi';
let hello = require('hellojs');

import firebase from 'firebase';
// Required for side-effects
require('firebase/firestore');

firebase.initializeApp({
    apiKey: 'AIzaSyCBMwtgS9VDMMoQxhBIez2zwxK0DfgCVpo',
    authDomain: 'missoffice2020-logs.firebaseapp.com',
    databaseURL: 'https://missoffice2020-logs.firebaseio.com',
    projectId: 'missoffice2020-logs',
    storageBucket: 'missoffice2020-logs.appspot.com',
    messagingSenderId: '328582295032',
    appId: '1:328582295032:web:c3ccf9ee9e6b4744d63a0d'
});

const db = firebase.firestore();

const HELLO_PROD_CONFIG = [
    {
        // facebook: 786449698596212,
        vk: 7623423,
        google: '953443733921-enpjqii24fbnn664bho9c790e0t5efie.apps.googleusercontent.com'
        // instagram:
        //     'IGQVJVYWxQb1ZA5WTkwREREeEVYRnZAlb2dnTHE1UTB1ZAkVwUXgtX09KYXlBQUNYeEJOd2NuZAmZACeWpVU2pCLUZAIdnQ3WjFLb0ROTFM3YTBtMEtoaWpNUnEzbzFmbU5IbEtHbVp6OXNPTTR0RjNLcW9TRQZDZD'
    },
    {
        oauth_proxy: 'https://auth-server.herokuapp.com/proxy',
        redirect_uri: 'https://missoffice2020.passion.ru/'
    }
];
const HELLO_DEV_CONFIG = [
    {
        // facebook: 786449698596212,
        vk: 7623423,
        google: '953443733921-enpjqii24fbnn664bho9c790e0t5efie.apps.googleusercontent.com'
    },
    {
        oauth_proxy: 'https://auth-server.herokuapp.com/proxy',
        redirect_uri: 'http://localhost:8080/'
    }
];

const helloConfig = isProd ? HELLO_PROD_CONFIG : HELLO_DEV_CONFIG;

hello.init(...helloConfig);

// hello.settings.scope.length = 0;
// hello.settings.scope = ['user_profile'];

// console.log(hello.settings.scope);

const clearStorageLoginInfo = () => {
    store.state.authstate = false;
    store.state.login.status = false;
    store.state.login.network = '';
    store.state.login.username = '';
    store.state.login.id = '';

    store.state.vote.voted = false;
    store.state.vote.id = false;
};

const sortLikesData = likesArr => {
    store.state.participants.forEach(girl => (girl.likes = 0));
    likesArr.forEach(like => {
        let grl = store.state.participants.find(el => Number(el.id) === Number(like.id));
        ++grl.likes;
    });
    return likesArr;
};

const checkAuthPersonLikeState = () => {
    // находим в массиве лайков голосовал ли этот аккаунт и заполняем информацию о его лайке
    let votedPerson = store.state.likesData.find(el => store.state.login.id === el._id);
    if (votedPerson) {
        store.state.vote.voted = true;
        store.state.vote.id = votedPerson.id;
    }
};

hello.on('auth.login', res => {
    store.state.authstate = false;
    store.state.login.status = true;
    store.state.login.network = res.network;

    // if (res.network === 'facebook') {
    //     hello('facebook')
    //         .api('me')
    //         .then(function(json) {
    //             store.state.login.id = json.id;
    //             store.state.login.username = json.name;
    //             checkAuthPersonLikeState();
    //         });
    // } else 
    if (res.network === 'google') {
        hello('google')
            .api('me')
            .then(function(json) {
                store.state.login.id = json.id;
                store.state.login.username = json.name;
                checkAuthPersonLikeState();
            });
    } else if (res.network === 'vk') {
        store.state.login.id = res.authResponse.user_id;
        store.state.login.username = res.authResponse.user_id;
        checkAuthPersonLikeState();
    }
});

hello.on('auth.logout', () => clearStorageLoginInfo());

import participants from '@/assets/data/participants.json';

const shuffle = array => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
};

shuffle(participants);

const store = new Vuex.Store({
    state: {
        participants,
        authstate: false,
        login: {
            id: '',
            network: '',
            status: false,
            username: ''
        },
        vote: {
            voted: false,
            id: false
        },
        likesData: [],
        pageLoaded: false,
        likeProcess: false,
        logsData: []
    },

    getters: {
        pageLoaded: state => {
            return state.pageLoaded;
        },

        likeProcess: state => {
            return state.likeProcess;
        },

        votedParticipantId: state => {
            if (state.vote.id !== false) {
                return Number(state.vote.id);
            } else {
                return false;
            }
        }
    },

    mutations: {
        setAuth(state, data) {
            state.authstate = data;
        },

        auth(state, network) {
            hello.login(network).then(res => {
                return res;
            });
        },

        logout(state) {
            hello.logout(state.login.network);
        },

        setPageLoaded(state) {
            state.pageLoaded = true;
        },

        setLike(state, id) {
            state, id;
            // // отключаем кнопки лайка до голосования
            // state.likeProcess = true;
            // // создаем объект для отправки в sanity
            // const doc = {
            //     _id: state.login.id,
            //     _type: 'item',
            //     network: `${state.login.network}`,
            //     username: `${state.login.username}`,
            //     id: `${id}`
            // };
            // SANITY.setLike(doc).then(res => {
            //     if (state.vote.voted) {
            //         --state.participants.find(girl => girl.id === Number(state.vote.id)).likes;
            //     }
            //     // включаем кнопки лайков для голосования
            //     state.likeProcess = false;
            //     // записываем в состояние результат голосования
            //     state.vote.voted = true;
            //     state.vote.id = Number(res.id);
            //     ++state.participants.find(girl => girl.id === Number(res.id)).likes;
            //     // Добавляем лог информацию в firebase
            //     db.collection('logs').add({
            //         network: state.login.network,
            //         username: state.login.username,
            //         missId: `${id}`,
            //         timestamp: firebase.firestore.FieldValue.serverTimestamp()
            //     });
            //     // записываем в состояние +1 лайк для участницы голосования
            //     // state.participants.find(girl => girl.id === Number(res.id)).likes = state.participants.find(girl => girl.id === Number(res.id)).likes + 1;
            // });
        },

        getLikesData(state) {
            const query = `*[_type == "item"] {
                _id,
                id,
                network,
                username
            }[0...6000]`;

            SANITY.getLikesData(query).then(res => {
                state.likesData = sortLikesData(res);

                if (state.login.status) {
                    checkAuthPersonLikeState();
                }
            });
        },

        getLogs(state) {
            state.logsData = [];
            db.collection('logs')
                .get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        state.logsData.push(doc.data());
                    });
                });
        }
    },

    actions: {
        setAuth(context, data) {
            context.commit('setAuth', data);
        },

        auth(context, network) {
            context.commit('auth', network);
        },

        logout(context) {
            context.commit('logout');
        },

        setLike(context, id) {
            context.commit('setLike', id);
        },

        getLikesData(context) {
            context.commit('getLikesData');
        },

        getLogs(context) {
            context.commit('getLogs');
        },

        setPageLoaded(context) {
            context.commit('setPageLoaded');
        }
    }
});

// let fb = hello('facebook').getAuthResponse();
let vk = hello('vk').getAuthResponse();
let go = hello('google').getAuthResponse();

if (vk || go) {
    store.state.login.status = true;

    // if (fb) {
    //     hello('facebook')
    //         .api('me')
    //         .then(function(json) {
    //             store.state.login.id = json.id;
    //         });
    //     store.state.login.network = fb.network;
    // } else 
    if (vk) {
        store.state.login.id = vk.user_id;
        store.state.login.username = vk.user_id;
        store.state.login.network = vk.network;
    } else if (go) {
        hello('google')
            .api('me')
            .then(function(json) {
                store.state.login.id = json.id;
            });
        store.state.login.network = go.network;
    }
}

export default store;
